import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { ShieldCheck, MapPin } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LEVEL = {
  full: { t: 'Full access', c: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  view: { t: 'View only', c: 'bg-amber-50 text-amber-700 border-amber-200' },
  off: { t: 'No access', c: 'bg-slate-100 text-slate-500 border-slate-200' },
};

// "What your role can do" — live from the clinic's Roles & Permissions and the user's branches.
export default function RoleGuideCard() {
  const [d, setD] = useState(null);
  useEffect(() => { axios.get(`${API}/role-permissions/my-summary`).then((r) => setD(r.data)).catch(() => setD(null)); }, []);
  if (!d) return null;
  const branchText = d.branches === 'all'
    ? 'All branches'
    : (d.branches.length ? d.branches.map((b) => b.name).join(', ') : 'No branch assigned (only records not tied to a branch)');
  return (
    <section className="rounded-xl bg-white border border-slate-200 p-5" data-testid="role-guide-card">
      <h2 className="text-sm font-bold text-slate-800 flex items-center gap-2">
        <ShieldCheck size={16} className="text-indigo-600" /> What your role can do
      </h2>
      <p className="text-[12px] text-slate-500 mt-1">
        You are signed in as <b data-testid="role-guide-role">{d.role_label}</b>. This reflects your clinic's current settings.
      </p>
      <div className="mt-3 flex items-start gap-2 text-[12px] text-slate-700" data-testid="role-guide-branches">
        <MapPin size={14} className="mt-0.5 text-slate-400 shrink-0" /> <span><b>Branches you see:</b> {branchText}</span>
      </div>
      <ul className="mt-3 grid sm:grid-cols-2 gap-x-6 gap-y-1.5">
        {d.modules.map((m) => (
          <li key={m.code} className="flex items-center justify-between gap-2 text-[12px] text-slate-700" data-testid={`role-guide-module-${m.code}`}>
            <span className="truncate">{m.label}</span>
            <span className={`shrink-0 text-[10px] font-semibold px-2 py-0.5 rounded-full border ${LEVEL[m.level]?.c || LEVEL.off.c}`}>{LEVEL[m.level]?.t || m.level}</span>
          </li>
        ))}
      </ul>
      <p className="text-[11px] text-slate-500 mt-3" data-testid="role-guide-footer">
        {d.can_edit_roles
          ? <>You can change what each role can do in <Link to="/settings/roles" className="text-indigo-600 hover:underline">Roles &amp; Permissions</Link>.</>
          : 'Need more access? Ask your clinic owner. Modules can also depend on your clinic\u2019s plan.'}
      </p>
    </section>
  );
}
